<template>
  <div class="container">
    <div class="handle-box">
      <el-form :model="queryCondition" ref="queryCondition" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item :label="$t('supplierManage.supplierInvitationCode')" prop="invitationCode">
                  <!--供应商邀请码-->
                  <el-input v-model.trim="queryCondition.invitationCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('supplierManage.supplierChinese')" prop="supplierName">
                  <!--供应商中文名称-->
                  <el-input v-model="queryCondition.supplierName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('supplierManage.supplierEnglish')" prop="supplierNameEn">
                  <!--供应商英文名称-->
                  <el-input v-model="queryCondition.supplierNameEn" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="supplierNameShort">
                  <!--供应商简称-->
                  <el-input v-model="queryCondition.supplierNameShort" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.InvitationCodeStatus')" prop="invitationCodeStatus">
                    <!--邀请码状态-->
                    <ic-select clearable table="TM_SUPPLIER" field="INVITATION_CODE_STATUS" v-model="queryCondition.invitationCodeStatus" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item :label="$t('supplierManage.auditStatus')" prop="auditStatus">
                    <!--审核状态-->
                    <ic-select clearable table="TM_SUPPLIER" field="AUDIT_STATUS" v-model="queryCondition.auditStatus" style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="邀请日期(从)" prop="invitationDateBegin">
                    <el-date-picker v-model="queryCondition.invitationDateBegin" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')" :picker-options="pickerOptionsStart" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="邀请日期(至)" prop="invitationDateEnd">
                    <el-date-picker v-model="queryCondition.invitationDateEnd" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')" :picker-options="pickerOptionsEnd" style="width:100%"></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" class="btn" @click="queryData(1)" type="primary">{{ $t('common.search') }}</el-button>
          <el-button size="mini" @click="restQueryForm" type="primary">{{ $t('common.reset') }}</el-button>
          <span class="arrowDown" @click="isShow = !isShow">{{ isShow ? '收缩' : '展开' }}<i :class="isShow ? 'el-icon-arrow-up iconBtn' : 'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <div class="action-btn-row">
      <el-button v-if="isShowFunc && isEmplFlag" size="mini" class="btn" type="primary" @click="addsupplierCode(-99999)" v-acl="SavePotentialSupplier">{{ $t('common.newBuilt') }}</el-button>
    </div>
    <el-table :data="tableList" ref="tableList" border highlight-current-row max-height='420'>
      <el-table-column min-width="100" show-overflow-tooltip prop="no" :label="$t('supplierManage.supplierInvitationCode')">
        <!--供应商邀请码-->
        <template slot-scope="scope">
          <div class="a-link" @click="toDetail(scope.row)">{{ scope.row.invitationCode }}</div>
        </template>
      </el-table-column>
      <el-table-column min-width="150" show-overflow-tooltip prop="supplierName" :label="$t('supplierManage.supplierChinese')"></el-table-column>
      <!--供应商中文名称-->
      <el-table-column min-width="150" show-overflow-tooltip prop="supplierNameEn" :label="$t('supplierManage.supplierEnglish')"></el-table-column>
      <!--供应商英文名称-->
      <el-table-column min-width="100" show-overflow-tooltip prop="supplierNameShort" :label="$t('supplierManage.supplierAbbreviation')"></el-table-column>
      <!--供应商简称-->
      <el-table-column min-width="100" show-overflow-tooltip prop="groupType" :label="$t('visitPlan.Type')">
        <template slot-scope="scope">{{ scope.row.groupType | ic('TM_SUPPLIER', 'GROUP_TYPE') }}</template>
      </el-table-column>
      <!--供应商类型-->
      <el-table-column min-width="80" show-overflow-tooltip prop="linkman" :label="$t('settlementUnit.contacts')">

      </el-table-column>
      <!--联系人-->
      <el-table-column min-width="80" show-overflow-tooltip prop="telephoneNo" :label="$t('common.contactNumber')"></el-table-column>
      <!--联系电话-->
      <el-table-column min-width="120" show-overflow-tooltip prop="emailAddress" :label="$t('sys.userList.email')"></el-table-column>
      <!--邮箱-->
      <el-table-column min-width="80" show-overflow-tooltip prop="invitationCodeStatusI18n" :label="$t('supplierManage.InvitationCodeStatus')"></el-table-column>
      <!--邀请码状态-->
      <el-table-column min-width="80" show-overflow-tooltip prop="auditStatusI18n" :label="$t('supplierManage.auditStatus')"></el-table-column>
      <!--审核状态-->
      <el-table-column min-width="100" show-overflow-tooltip prop="description" :label="$t('common.remarks')"></el-table-column>
      <!--备注-->
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
    </div>
    <el-dialog v-if="IsSupplierCodeDialog" :visible.sync="supplierCodeDialog" width="40%" class="supplierCodeDialog">
      <el-form :model="addsupplierCodeForm" ref="addsupplierCodeRef" :rules="addsupplierCodeRules" label-width="120px">
        <el-row>
          <el-col :span="12">
            <!-- 创建人 -->
            <el-form-item :label="$t('supplierManage.creater')" prop="createBy">
              <el-input v-model="addsupplierCodeForm.createBy" disabled class="handle-input" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <!-- 创建日期 -->
            <el-form-item :label="$t('supplierManage.creationDate')" prop="creationDate">
              <el-input v-model="addsupplierCodeForm.creationDate" disabled class="handle-input" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <!-- 供应商类型 -->
          <el-form-item :label="$t('supplierManage.supplierType')" prop="groupType">
            <ic-select clearable table="TM_SUPPLIER" field="GROUP_TYPE" :excludes="['CARRIER']" v-model="addsupplierCodeForm.groupType"></ic-select>
          </el-form-item>
        </el-row>
        <el-row>
          <!-- 国内/国外 -->
          <el-form-item :label="$t('supplierManage.DomesticOrforeign')" prop="homeOrAbroad">
            <el-radio-group v-model="addsupplierCodeForm.homeOrAbroad">
              <el-radio label="IN">{{ $t('supplierManage.domestic') }}</el-radio>
              <el-radio label="OUT">{{ $t('supplierManage.abroad') }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('supplierManage.supplierChinese')" prop="supplierName">
            <!--供应商中文名称-->
            <el-input v-model="addsupplierCodeForm.supplierName" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('supplierManage.supplierEnglish')" prop="supplierNameEn">
            <!--供应商英文名称-->
            <el-input v-model="addsupplierCodeForm.supplierNameEn" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('supplierManage.supplierAbbreviation')" prop="supplierNameShort">
            <!--供应商简称-->
            <el-input v-model="addsupplierCodeForm.supplierNameShort" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item :label="$t('supplierManage.expiryDate')" prop="invitationCodeEndDate">
            <!--有效期-->
            <el-date-picker value-format="yyyy-MM-dd" v-model="addsupplierCodeForm.invitationCodeEndDate" type="date" :placeholder="$t('common.selDate')" :picker-options="pickerOptions"></el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item class="email" v-for="(email, index) in addsupplierCodeForm.emailAddress" :label="$t('sys.userList.email')" :key="email.key" :prop="'emailAddress.' + index + '.value'" :rules="addsupplierCodeRules.emailAddress">
            <el-input v-model="email.value"></el-input>
            <el-button size="mini" @click="addEmail" v-if="index == 0">{{ $t('common.add') }}</el-button>
            <el-button size="mini" @click.prevent="removeEmail(email)" v-if="index != 0">{{ $t('common.del')
            }}</el-button>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button size="mini" type="primary" @click="supplierCodeDialog = false">{{ $t('common.close') }}</el-button>
        <el-button size="mini" type="primary" @click="saveSupplier">{{ $t('common.submit') }}</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import supplierApi from "@/api/supplier/supplier";
import commonFun from "@/utils/commonFun";
export default {
  components: { IcSelect },
  name: "",

  data() {
    var validatorEmailAddress = (rule, value, callback) => {
      if (commonFun.isEmpty(value)) {
        return callback(new Error(this.$t("visitPlan.noEmpty")));
      }
      let reg = /^[A-Za-z0-9\u4e00-\u9fa5_\-\.-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (!reg.test(value)) {
        callback(new Error(this.$t("sys.userList.inputEmail")));
      } else {
        callback();
      }
    };
    return {
      pickerOptions: {
        disabledDate(date) {
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
      },
      isShow: false,//控制查询列表收缩展开
      // dataArr: [],
      queryCondition: {
        invitationCode: '',
        supplierName: '',
        supplierNameEn: '',
        supplierNameShort: '',
        invitationCodeStatus: '',
        auditStatus: '',
        invitationDateBegin: '',
        invitationDateEnd: '',
        pageNum: 1,
        pageSize: 15,
      },
      addsupplierCodeForm: {
        createBy: localStorage.getItem("ms_userCd"),
        creationDate: this.$options.filters["dateFormatFilter"](new Date()),
        invitationCodeEndDate: '',
        emailAddress: [{
          value: ''
        }],
      },
      supplierCodeDialog: false,
      IsSupplierCodeDialog: false,
      isShowFunc: true,
      isEmplFlag: true,
      tableList: [],
      addsupplierCodeRules: {
        groupType: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        homeOrAbroad: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        supplierName: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        supplierNameEn: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        supplierNameShort: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        invitationCodeEndDate: [
          { required: true, message: this.$t("common.canNotBeEmpty"), trigger: "blur" }
        ],
        emailAddress: [
          { required: true, trigger: "blur", validator: validatorEmailAddress }
        ],
        emplFlag: '',
      },
      // pickerOptionsStart: {
      //   // 开始时间小于结束时间
      //   disabledDate: time => {
      //     let endTime = this.queryCondition.invitationDateEnd;
      //     if (endTime) {
      //       return time.getTime() > new Date(endTime).getTime();
      //     }
      //   }
      // },
      // pickerOptionsEnd: {
      //   disabledDate: time => {
      //     let beginTime = this.queryCondition.invitationDateBegin;
      //     if (beginTime) {
      //       return time.getTime() < new Date(beginTime).getTime() - 24 * 60 * 60 * 1000;
      //     }
      //   }
      // },

    };
  },
  created() {
    this.queryData();
    // this.addsupplierCodeForm.invitationCodeEndDate = ''

  },
  mounted() {
    let dataScope = JSON.parse(localStorage.getItem("ms_DataScope"));
    let groupableSupplier = localStorage.getItem("groupableSupplier")//true是HGS供应商
    console.log('groupableSupplier', groupableSupplier);
    const emplFlag = localStorage.getItem("ms_emplFlag");
    console.log('emplFlag', emplFlag);
    // if (groupableSupplier !== 'false') {
    //   if (dataScope) {
    //     if (dataScope.indexOf('SUPPLIER_GROUPING') !== -1 || dataScope.indexOf('MATERIALS_AND_FPA_MAINTAINER') !== -1 || dataScope.indexOf('MATERIALS_MAINTAINER') !== -1) {
    //       this.isShowFunc = false
    //     } else {
    //       this.isShowFunc = true
    //     }
    //   }
    // } else {
    //   //供应商用户
    if (emplFlag === 'SUP') {
      this.isEmplFlag = false;
    } else {
      this.isEmplFlag = true;
    }
    // }
    console.log('isEmplFlag', this.isEmplFlag);
    console.log('isShowFunc', this.isShowFunc);
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      supplierApi.getList(this.queryCondition).then(res => {
        this.tableList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    addsupplierCode() {
      let date = new Date
      this.addsupplierCodeForm.invitationCodeEndDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate() + 14);
      this.supplierCodeDialog = true
      this.IsSupplierCodeDialog = true
    },
    toDetail(row) {
      console.log("🚀 ~ toDetail ~ row:", row)
      if (row.groupType == "CARRIER") {
        this.$router.push({
          path: `/potentialSupplierManageList-detail/view`,
          query: { tmSupplierId: row.tmSupplierId, groupType: row.groupType }
        });
      } else {
        this.$router.push({
          path: `/potentialSupplierManageList-detail`,
          query: { tmSupplierId: row.tmSupplierId, groupType: row.groupType }
        });
      }
    },
    saveSupplier() {
      let that = this;
      this.$refs.addsupplierCodeRef.validate(valid => {
        if (valid) {
          let emailList = that.addsupplierCodeForm.emailAddress
          var temp = emailList.map(function (item) {
            return item["value"];
          });
          let data = {
            groupType: that.addsupplierCodeForm.groupType,
            homeOrAbroad: that.addsupplierCodeForm.homeOrAbroad,
            supplierName: that.addsupplierCodeForm.supplierName,
            supplierNameEn: that.addsupplierCodeForm.supplierNameEn,
            supplierNameShort: that.addsupplierCodeForm.supplierNameShort,
            invitationCodeEndDate: that.addsupplierCodeForm.invitationCodeEndDate,
            emailAddress: temp.join(";"),
          }
          supplierApi.saveSupplier(data).then(res => {
            if (res.code == '200') {
              this.addsupplierCodeForm = {//保存成功后 清除数据
                createBy: localStorage.getItem("ms_userCd"),
                creationDate: this.$options.filters["dateFormatFilter"](new Date()),
                emailAddress: [{
                  value: ''
                }],
              }
              this.supplierCodeDialog = false
              that.$message({
                message: this.$t("common.saveSuccess"),
                type: "success"
              });
              this.queryData(1)
            }
          });
        } else {
          Message({ message: that.$t('common.PleaseRequired'), type: "error" });
          return false;
        }
      });
    },
    addEmail() {
      this.addsupplierCodeForm.emailAddress.push({
        value: '',
        key: Date.now()
      });
    },
    removeEmail(item) {
      var index = this.addsupplierCodeForm.emailAddress.indexOf(item)
      if (index !== -1) {
        this.addsupplierCodeForm.emailAddress.splice(index, 1)
      }
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        invitationCode: '',
        supplierName: '',
        supplierNameEn: '',
        supplierNameShort: '',
        invitationCodeStatus: '',
        auditStatus: '',
        invitationDateBegin: '',
        invitationDateEnd: '',
        pageNum: 1,
        pageSize: 15,
      }
      this.queryData();
    },

  },
  extends: commonFunction
};
</script>
<style lang="scss">
.supplierCodeDialog .email.el-form-item .el-form-item__content {
  display: flex;
}

.potentialSupplierManageList {
  .createDateArr .el-form-item__content {
    display: flex;
  }

  .el-date-editor {
    width: 100%;
  }

  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    content: "";
  }
}
</style>
